// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================= POSITION MONITOR STACK ================= */

.positionMonitorStack {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}

.monitorCard {
  min-width: 0;
  overflow: hidden;
}

.compactPanelHeader {
  margin-bottom: 12px;
}

/* ================= TABLE ================= */

.dataTable {
  width: 100%;
  border-collapse: collapse;
}

.positionMonitorTable {
  width: 100%;
  table-layout: fixed;
}

.compactTable th,
.compactTable td {
  padding: 10px 6px;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  vertical-align: middle;
  overflow: hidden;
}

.compactTable th {
  color: rgba(235, 240, 255, 0.62);
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.035em;
  white-space: nowrap;
}

.compactTable td {
  color: rgba(245, 247, 255, 0.88);
  font-size: 0.84rem;
  line-height: 1.18;
}

.compactTable tbody tr:last-child td {
  border-bottom: none;
}

/* Strategy | Structure | Entry/Exit | Trade Setup | OPEX | Credit */

.positionMonitorTable th:nth-child(1),
.positionMonitorTable td:nth-child(1) {
  width: 13%;
}

.positionMonitorTable th:nth-child(2),
.positionMonitorTable td:nth-child(2) {
  width: 15%;
}

.positionMonitorTable th:nth-child(3),
.positionMonitorTable td:nth-child(3) {
  width: 8%;
}

.positionMonitorTable th:nth-child(4),
.positionMonitorTable td:nth-child(4) {
  width: 43%;
}

.positionMonitorTable th:nth-child(5),
.positionMonitorTable td:nth-child(5) {
  width: 10%;
}

.positionMonitorTable th:nth-child(6),
.positionMonitorTable td:nth-child(6) {
  width: 11%;
}

/* ================= TRADE SETUP ================= */

.tradeSetup {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 10px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.tradeSide {
  display: grid;
  grid-template-rows: auto auto auto;
  gap: 4px;
  min-width: 0;
}

.tradeSideLabel {
  color: rgba(255, 255, 255, 0.48);
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  white-space: nowrap;
}

.tradeLeg {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  align-items: center;
  column-gap: 5px;
  min-width: 0;
  line-height: 1;
}

.tradeLegAction {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  font-size: 0.58rem;
  font-weight: 900;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.tradeLegAction.sell {
  color: #ff6b6b;
  background: rgba(255, 91, 91, 0.14);
  border: 1px solid rgba(255, 91, 91, 0.42);
}

.tradeLegAction.buy {
  color: #42ff9b;
  background: rgba(66, 255, 155, 0.12);
  border: 1px solid rgba(66, 255, 155, 0.36);
}

.tradeLegStrike {
  min-width: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.82rem;
  font-weight: 750;
  letter-spacing: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ================= STATE COLORS ================= */

.positive {
  color: #42ff9b !important;
}

.negative {
  color: #ff5a6a !important;
}

/* ================= EMPTY STATE ================= */

.emptyTableCell {
  padding: 18px 8px !important;
  text-align: center !important;
  color: rgba(245, 247, 255, 0.48) !important;
  font-size: 0.86rem;
}

/* ================= SMALL SCREEN FALLBACK ================= */

@media (max-width: 900px) {
  .monitorCard {
    overflow-x: auto;
  }

  .positionMonitorTable {
    min-width: 760px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Styles/PositionMonitorStack.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8CAA8C;;AAE9C;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,kDAAkD;EAClD,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oEAAoE;;AAEpE;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;EACb,oDAAoD;EACpD,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qDAAqD;;AAErD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oDAAoD;;AAEpD;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA,8DAA8D;;AAE9D;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* ================= POSITION MONITOR STACK ================= */\n\n.positionMonitorStack {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-width: 0;\n}\n\n.monitorCard {\n  min-width: 0;\n  overflow: hidden;\n}\n\n.compactPanelHeader {\n  margin-bottom: 12px;\n}\n\n/* ================= TABLE ================= */\n\n.dataTable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.positionMonitorTable {\n  width: 100%;\n  table-layout: fixed;\n}\n\n.compactTable th,\n.compactTable td {\n  padding: 10px 6px;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  vertical-align: middle;\n  overflow: hidden;\n}\n\n.compactTable th {\n  color: rgba(235, 240, 255, 0.62);\n  font-size: 0.76rem;\n  font-weight: 800;\n  letter-spacing: 0.035em;\n  white-space: nowrap;\n}\n\n.compactTable td {\n  color: rgba(245, 247, 255, 0.88);\n  font-size: 0.84rem;\n  line-height: 1.18;\n}\n\n.compactTable tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Strategy | Structure | Entry/Exit | Trade Setup | OPEX | Credit */\n\n.positionMonitorTable th:nth-child(1),\n.positionMonitorTable td:nth-child(1) {\n  width: 13%;\n}\n\n.positionMonitorTable th:nth-child(2),\n.positionMonitorTable td:nth-child(2) {\n  width: 15%;\n}\n\n.positionMonitorTable th:nth-child(3),\n.positionMonitorTable td:nth-child(3) {\n  width: 8%;\n}\n\n.positionMonitorTable th:nth-child(4),\n.positionMonitorTable td:nth-child(4) {\n  width: 43%;\n}\n\n.positionMonitorTable th:nth-child(5),\n.positionMonitorTable td:nth-child(5) {\n  width: 10%;\n}\n\n.positionMonitorTable th:nth-child(6),\n.positionMonitorTable td:nth-child(6) {\n  width: 11%;\n}\n\n/* ================= TRADE SETUP ================= */\n\n.tradeSetup {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  column-gap: 10px;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.tradeSide {\n  display: grid;\n  grid-template-rows: auto auto auto;\n  gap: 4px;\n  min-width: 0;\n}\n\n.tradeSideLabel {\n  color: rgba(255, 255, 255, 0.48);\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.tradeLeg {\n  display: grid;\n  grid-template-columns: 18px minmax(0, 1fr);\n  align-items: center;\n  column-gap: 5px;\n  min-width: 0;\n  line-height: 1;\n}\n\n.tradeLegAction {\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  font-size: 0.58rem;\n  font-weight: 900;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tradeLegAction.sell {\n  color: #ff6b6b;\n  background: rgba(255, 91, 91, 0.14);\n  border: 1px solid rgba(255, 91, 91, 0.42);\n}\n\n.tradeLegAction.buy {\n  color: #42ff9b;\n  background: rgba(66, 255, 155, 0.12);\n  border: 1px solid rgba(66, 255, 155, 0.36);\n}\n\n.tradeLegStrike {\n  min-width: 0;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.82rem;\n  font-weight: 750;\n  letter-spacing: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ================= STATE COLORS ================= */\n\n.positive {\n  color: #42ff9b !important;\n}\n\n.negative {\n  color: #ff5a6a !important;\n}\n\n/* ================= EMPTY STATE ================= */\n\n.emptyTableCell {\n  padding: 18px 8px !important;\n  text-align: center !important;\n  color: rgba(245, 247, 255, 0.48) !important;\n  font-size: 0.86rem;\n}\n\n/* ================= SMALL SCREEN FALLBACK ================= */\n\n@media (max-width: 900px) {\n  .monitorCard {\n    overflow-x: auto;\n  }\n\n  .positionMonitorTable {\n    min-width: 760px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
